import { render, staticRenderFns } from "./req-item.vue?vue&type=template&id=8eed10da&scoped=true"
import script from "./req-item.vue?vue&type=script&lang=js"
export * from "./req-item.vue?vue&type=script&lang=js"
import style0 from "./req-item.vue?vue&type=style&index=0&id=8eed10da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eed10da",
  null
  
)

export default component.exports